import { FC, SVGProps } from 'react';

export const EventDetailsIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M9 5.75C7.20507 5.75 5.75 7.20508 5.75 9V26.5C5.75 26.9142 5.41421 27.25 5 27.25C4.58579 27.25 4.25 26.9142 4.25 26.5V9C4.25 6.37665 6.37665 4.25 9 4.25H23C25.6234 4.25 27.75 6.37665 27.75 9V26.5C27.75 26.9142 27.4142 27.25 27 27.25C26.5858 27.25 26.25 26.9142 26.25 26.5V9C26.25 7.20507 24.7949 5.75 23 5.75H9Z"
			fill="currentColor"
		/>
		<path
			d="M9.25 11.5C9.25 11.0858 9.58579 10.75 10 10.75H11C11.4142 10.75 11.75 11.0858 11.75 11.5C11.75 11.9142 11.4142 12.25 11 12.25H10C9.58579 12.25 9.25 11.9142 9.25 11.5Z"
			fill="currentColor"
		/>
		<path
			d="M10 16C9.58579 16 9.25 16.3358 9.25 16.75C9.25 17.1642 9.58579 17.5 10 17.5H11C11.4142 17.5 11.75 17.1642 11.75 16.75C11.75 16.3358 11.4142 16 11 16H10Z"
			fill="currentColor"
		/>
		<path
			d="M9.25 21.75C9.25 21.3358 9.58579 21 10 21H11C11.4142 21 11.75 21.3358 11.75 21.75C11.75 22.1642 11.4142 22.5 11 22.5H10C9.58579 22.5 9.25 22.1642 9.25 21.75Z"
			fill="currentColor"
		/>
		<path
			d="M14.5 10.75C14.0858 10.75 13.75 11.0858 13.75 11.5C13.75 11.9142 14.0858 12.25 14.5 12.25H22.5C22.9142 12.25 23.25 11.9142 23.25 11.5C23.25 11.0858 22.9142 10.75 22.5 10.75H14.5Z"
			fill="currentColor"
		/>
		<path
			d="M13.75 16.75C13.75 16.3358 14.0858 16 14.5 16H22.5C22.9142 16 23.25 16.3358 23.25 16.75C23.25 17.1642 22.9142 17.5 22.5 17.5H14.5C14.0858 17.5 13.75 17.1642 13.75 16.75Z"
			fill="currentColor"
		/>
		<path
			d="M14.5 21C14.0858 21 13.75 21.3358 13.75 21.75C13.75 22.1642 14.0858 22.5 14.5 22.5H22.5C22.9142 22.5 23.25 22.1642 23.25 21.75C23.25 21.3358 22.9142 21 22.5 21H14.5Z"
			fill="currentColor"
		/>
	</svg>
);
